import { Component } from '@angular/core';

@Component({
    selector: 'app-symbol',
    templateUrl: './symbol.component.html',
    styleUrls: ['./symbol.component.scss'],
    standalone: true
})
export class SymbolComponent {
}
